module.exports = __webpack_public_path__ + "static/media/umbrella_new.4015ad45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/umbrella_new.svg
// module id = 3200
// module chunks = 0